// extracted by mini-css-extract-plugin
export var formFieldError = "newsletter-module--form-field-error--ad9dd";
export var formFieldWrapperOptin = "newsletter-module--formFieldWrapperOptin--70815";
export var mailchimpResponse = "newsletter-module--mailchimp-response--391ca";
export var newsLetter = "newsletter-module--news-letter--688f7";
export var newsletterForm = "newsletter-module--newsletter-form--0e029";
export var newsletterMain = "newsletter-module--newsletter-main--b58ed";
export var response = "newsletter-module--response--bca99";